module.exports = __webpack_public_path__ + "img/undraw_personal_email_t7nw.10cf0af4.svg";